import { render } from "./Home.vue?vue&type=template&id=82d5277a"
const script = {}

import "./Home.vue?vue&type=style&index=0&id=82d5277a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__